import React from 'react';

function Contact() {
  const handleSubmit = (event) => {
    event.preventDefault();
    const { name, email, message } = event.target.elements;
    const mailtoUrl = `mailto:luuqebusiness@gmail.com?subject=${encodeURIComponent('Message from ' + name.value)}&body=${encodeURIComponent(message.value + '\n\nSent from ' + email.value + ' via ' + window.location.host)}`;
    window.location.href = mailtoUrl;
  };

  return (
    <section id="contact" className="py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-8">Contact Me</h2>
        <div className="max-w-lg mx-auto">
          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            Have a question or want to work together? Feel free to get in touch!
          </p>
          <form className="space-y-4" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
              <input type="text" id="name" name="name" className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
              <input type="email" id="email" name="email" className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
            </div>
            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700">Message</label>
              <textarea id="message" name="message" rows="4" className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" minLength='25'></textarea>
            </div>
            <button type="submit" className="inline-block bg-indigo-500 text-white px-4 py-2 rounded-md hover:bg-indigo-600 focus:outline-none focus:bg-indigo-600">Submit</button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;
